// comunicaciones-api.js · llamadas de #1683 (comunicaciones, baja, eliminar la cuenta).
//
// Cubre R49, R54, R55, R56 — .claude/specs/1683-derechos-usuario/
//
// Dos clientes a propósito:
//  - Lo de la Cuenta (PATCH comunicaciones, eliminar, cancelar suscripción) va por `getClient()`,
//    con el token de la sesión.
//  - La baja pública (`/baja?t=...`) va con axios pelado, SIN el interceptor de `get-client` que
//    pega `Authorization` si hay un `authToken` en localStorage. R56: esa página no usa sesión, y el
//    backend tampoco la lee. Mandar el token de una sesión que puede ser de OTRA persona (un
//    computador compartido abre el link del correo de un colega) mezclaría dos identidades en una
//    llamada que es solo del dueño del link. La ruta sigue respetando el camino directo/proxy
//    que la sesión ya comprobó (`urlApi`).
import axios from "axios";
import getClient from "./get-client";
import { urlApi } from "./api-base";

/** PATCH /api/user/me/comunicaciones/ → el bloque `comunicaciones` que confirma el servidor. */
export const patchComunicaciones = async (cambios) => {
  const r = await getClient().patch("/api/user/me/comunicaciones/", cambios);
  return r.data;
};

/**
 * POST /api/user/comunicaciones/baja/ con el token del link. Sin `cambios` = baja de los correos de
 * seguimiento; con `{correo_seguimiento: true}` vuelve a suscribir; con `{whatsapp: false}` apaga
 * WhatsApp. Devuelve `{email, correo_seguimiento, whatsapp, whatsapp_disponible}`.
 */
export const postBaja = async (token, cambios = {}) => {
  const r = await axios.post(
    urlApi("/api/user/comunicaciones/baja/"),
    { token, ...cambios },
    { withCredentials: false, headers: { "Content-Type": "application/json" } }
  );
  return r.data;
};

/** POST /api/user/me/eliminar/ → {eliminada: true, modo}. Levanta con `response.data.code`. */
export const postEliminarCuenta = async (confirmacion) => {
  const r = await getClient().post("/api/user/me/eliminar/", { confirmacion });
  return r.data;
};

/**
 * POST /api/billing/me/subscription/cancel/ → el bloque `suscripcion` de /me. `origen` solo cambia el
 * texto del aviso a Sebastián (el diálogo de eliminar cuenta y Mi suscripción usan el mismo endpoint):
 * "mi_suscripcion" (por defecto) o "eliminar_cuenta".
 */
export const postCancelarSuscripcion = async (origen = "mi_suscripcion") => {
  const r = await getClient().post("/api/billing/me/subscription/cancel/", { origen });
  return r.data;
};

/** Código de error de la API ({code}) o "" si no vino. */
export const codigoDeError = (err) => String(err?.response?.data?.code || "");
